var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaperBookmarkClient(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Advisor home / bookmarks"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 39.1301,
    cy: 25.7561,
    r: 11.5217,
    stroke: "#212945",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8599 47.0517C46.1041 45.5265 42.4162 44.8477 38.364 44.8477C30.142 44.8477 21.0004 50.7327 21.0004 56.584C21.0004 58.0528 20.9453 58.9728 21.3655 59.5417C22.3346 60.8537 25.8318 60.2983 38.364 60.2983C40.5427 60.2983 42.4202 60.2983 44.0376 60.2896C43.8986 59.4956 43.8262 58.6786 43.8262 57.8448C43.8262 53.5118 45.7824 49.6358 48.8599 47.0517Z",
    fill: "#EEF0F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval (Stroke)",
    d: "M25.3247 48.0916C28.7733 45.7269 33.6482 44.1997 39.1304 44.1997C42.979 44.1997 46.5287 44.9524 49.4958 46.2194C49.8161 46.3561 50.1837 46.339 50.4858 46.162C51.211 45.7371 51.189 44.6811 50.4074 44.3434C47.1405 42.9322 43.2738 42.1164 39.1304 42.1164C33.2823 42.1164 27.9844 43.7417 24.1465 46.3734C20.309 49.0049 17.925 52.6478 17.925 56.6808V56.6846C17.925 57.7313 17.925 58.6185 18.0089 59.3668C18.093 60.1166 18.262 60.7347 18.6055 61.24C18.9781 61.788 19.5498 62.1943 20.4173 62.4966C21.2834 62.7984 22.4488 62.9981 24.0152 63.1311C27.1473 63.3968 31.9044 63.3968 39.1247 63.3968H39.1304C40.7378 63.3968 42.223 63.3968 43.5952 63.3939C44.2785 63.3925 44.7742 62.7442 44.598 62.0842C44.4759 61.627 44.0612 61.3096 43.588 61.3106C42.222 61.3135 40.7398 61.3135 39.1304 61.3135C33.8323 61.3135 29.9124 61.3132 26.9845 61.211C24.0072 61.107 22.2756 60.9002 21.2435 60.5758C20.7582 60.4233 20.5366 60.2762 20.4351 60.1876C20.3541 60.1168 20.2877 60.0319 20.2236 59.8508C20.1304 59.5869 20.076 59.2462 20.0454 58.7431C20.0149 58.2403 20.0083 57.5806 20.0083 56.6808C20.0083 53.5337 21.867 50.4626 25.3247 48.0916Z",
    fill: "#212945",
    stroke: "#212945",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "star",
    d: "M57.5001 61.5664L53.38 63.8595C53.198 63.9666 53.0077 64.0124 52.8091 63.9971C52.6105 63.9818 52.4368 63.9207 52.2879 63.8137C52.139 63.7067 52.0231 63.5729 51.9404 63.4124C51.8577 63.2519 51.8411 63.0722 51.8908 62.8735L52.9829 58.5395L49.3343 55.6272C49.1688 55.4896 49.0654 55.3329 49.024 55.1571C48.9826 54.9813 48.9951 54.8093 49.0612 54.6411C49.1274 54.473 49.2267 54.3354 49.3591 54.2284C49.4915 54.1213 49.6735 54.0526 49.9051 54.022L54.7203 53.6321L56.5818 49.5504C56.6645 49.3669 56.7928 49.2293 56.9665 49.1376C57.1403 49.0459 57.3181 49 57.5001 49C57.6822 49 57.86 49.0459 58.0338 49.1376C58.2075 49.2293 58.3358 49.3669 58.4185 49.5504L60.28 53.6321L65.0952 54.022C65.3268 54.0526 65.5088 54.1213 65.6412 54.2284C65.7736 54.3354 65.8729 54.473 65.9391 54.6411C66.0052 54.8093 66.0177 54.9813 65.9763 55.1571C65.9349 55.3329 65.8315 55.4896 65.666 55.6272L62.0174 58.5395L63.1095 62.8735C63.1592 63.0722 63.1426 63.2519 63.0599 63.4124C62.9772 63.5729 62.8613 63.7067 62.7124 63.8137C62.5635 63.9207 62.3898 63.9818 62.1912 63.9971C61.9926 64.0124 61.8023 63.9666 61.6203 63.8595L57.5001 61.5664Z",
    fill: "#EEF0F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "star_2",
    d: "M57.9128 63.5328L53.3606 66.2846C53.1595 66.413 52.9492 66.468 52.7299 66.4497C52.5105 66.4313 52.3185 66.358 52.154 66.2295C51.9894 66.1011 51.8615 65.9406 51.77 65.748C51.6786 65.5554 51.6604 65.3398 51.7152 65.1013L52.9218 59.9005L48.8906 56.4057C48.7078 56.2406 48.5936 56.0526 48.5479 55.8416C48.5021 55.6307 48.5159 55.4243 48.589 55.2225C48.6621 55.0207 48.7718 54.8556 48.9181 54.7272C49.0643 54.5987 49.2654 54.5162 49.5214 54.4795L54.8414 54.0117L56.8981 49.1135C56.9896 48.8934 57.1312 48.7283 57.3232 48.6182C57.5152 48.5082 57.7117 48.4531 57.9128 48.4531C58.1139 48.4531 58.3104 48.5082 58.5024 48.6182C58.6943 48.7283 58.836 48.8934 58.9274 49.1135L60.9842 54.0117L66.3042 54.4795C66.5602 54.5162 66.7613 54.5987 66.9075 54.7272C67.0538 54.8556 67.1635 55.0207 67.2366 55.2225C67.3097 55.4243 67.3234 55.6307 67.2777 55.8416C67.232 56.0526 67.1178 56.2406 66.9349 56.4057L62.9038 59.9005L64.1104 65.1013C64.1652 65.3398 64.1469 65.5554 64.0555 65.748C63.9641 65.9406 63.8361 66.1011 63.6716 66.2295C63.5071 66.358 63.3151 66.4313 63.0957 66.4497C62.8763 66.468 62.6661 66.413 62.465 66.2846L57.9128 63.5328Z",
    stroke: "#212945",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bling"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M12.6673 36.916V39.5827",
    stroke: "#5B6792",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    d: "M12.6673 44.916V47.5827",
    stroke: "#5B6792",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    d: "M7.33398 42.2487H10.0007",
    stroke: "#5B6792",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_4",
    d: "M15.334 42.2487H18.0007",
    stroke: "#5B6792",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bling_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_5",
    d: "M61.3333 12.25V14.9167",
    stroke: "#5B6792",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_6",
    d: "M61.3333 20.25V22.9167",
    stroke: "#5B6792",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_7",
    d: "M56 17.5827H58.6667",
    stroke: "#5B6792",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_8",
    d: "M64 17.5827H66.6667",
    stroke: "#5B6792",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Oval-3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4848 20.4196C36.4848 25.5674 40.6456 29.7406 45.7782 29.7406C46.7865 29.7406 47.7573 29.5795 48.6663 29.2817C47.1825 32.975 43.5755 35.582 39.3613 35.582C33.8228 35.582 29.333 31.0789 29.333 25.524C29.333 20.4904 33.0196 16.3205 37.8324 15.582C36.9773 16.9927 36.4848 18.6485 36.4848 20.4196Z",
    fill: "#EEF0F8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperBookmarkClient);
export default __webpack_public_path__ + "static/media/paperBookmarkClient.abbd5ad00a13956023cf3e8056c292c7.svg";
export { ForwardRef as ReactComponent };